package br.com.vvrefeicoes.portal.core.util

/** Converte um instant ISO (ex.: `2026-10-01T12:00:00Z`) para `dd/MM/aaaa às HH:mm`. */
fun formatIsoDateTime(value: String?): String {
    if (value == null || value.length < 16) return value.orEmpty()
    val date = "${value.substring(8, 10)}/${value.substring(5, 7)}/${value.substring(0, 4)}"
    val time = "${value.substring(11, 13)}:${value.substring(14, 16)}"
    return "$date às $time"
}

/** Converte um instant ISO (ex.: `2026-10-01T12:00:00Z`) para `dd/MM/aaaa`. */
fun formatIsoDate(value: String?): String {
    if (value == null || value.length < 10) return value.orEmpty()
    return "${value.substring(8, 10)}/${value.substring(5, 7)}/${value.substring(0, 4)}"
}
